// import './primary-button.component.scss';
// import { IButtonProps, PrimaryButton } from '@fluentui/react/lib/Button';

// export const PrimaryBtn: React.FunctionComponent<IButtonProps> = (props) => {
//     return (
//         <>
//             <PrimaryButton className='primary-btn' {...props} />
//         </>
//     );
// }

import './primary-button.component.scss';
import Button from '@mui/material/Button';
import { ButtonProps } from '@mui/material';

export const PrimaryButton: React.FunctionComponent<ButtonProps> = (props) => {
    return (
        <>
            <Button variant={props.variant ?? "contained"} {...props}>{props.children}</Button>
        </>
    );
}